import { TranslationsSchema } from './types'

const lang = document.documentElement.lang ?? 'fr'

let translations: TranslationsSchema

switch (lang) {
  case 'de':
    translations = await import('./i18n/de').then((module) => module.translations)
    break
  case 'en':
    translations = await import('./i18n/en').then((module) => module.translations)
    break
  case 'es':
    translations = await import('./i18n/es').then((module) => module.translations)
    break
  case 'it':
    translations = await import('./i18n/it').then((module) => module.translations)
    break
  case 'pt':
    translations = await import('./i18n/pt').then((module) => module.translations)
    break
  case 'fr':
  default:
    translations = await import('./i18n/fr').then((module) => module.translations)
    break
}

export function t(
  key: keyof TranslationsSchema | (string & {}),
  params?: Record<string, string>
): string {
  // @ts-expect-error
  let value: string = translations[key] ?? key

  // Replace parameters in the string
  if (params) {
    return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
      return params[paramKey] || match
    })
  }

  return value
}
